// extracted by mini-css-extract-plugin
module.exports = {"productAnimation":"ProductAnimation_productAnimation__TMptU","ef-box":"ProductAnimation_ef-box__6Hmqy"};